import { formatDateDayMonthYearTime, toLocaleNumber } from "../";

export const tariffMonthlyColumns = (
  data: any,
  gettext: (key: string) => string,
  locale: string,
  from = "month",
) => {
  const columns: any[] = [];
  if (from === "month") {
    // from month data
    // const consumptionData = data?.consumptionEnergyData?.consumptionData;

    const metersData = data?.tariffDetails?.metersInfo;
    // const metersData = data?.tariffDetails?.taxes["nettariffHourly"];
    if (Array.isArray(metersData) && metersData.length > 0) {
      columns.push(dateColumn(gettext));
      columns.push(numberColumn("sum", gettext("Sum"), locale, 150));
      // const dataForColumns = data.monthlyStatementData.metersData;
      metersData.map((obj: any): null => {
        columns.push(numberColumn(obj.meter, obj.meter, locale));
        return null;
      });
    }
  } else {
    // from year data
    columns.push(dateColumn(gettext));
    columns.push(numberColumn("sum", gettext("Sum"), locale, 150));
    data.map((obj: any): null => {
      columns.push(numberColumn(obj.meter, obj.meter, locale));
      return null;
    });
  }

  return columns;
};

const dateColumn = (gettext: (key: string) => string) => {
  return {
    field: "ts",
    headerName: gettext("Installation Numbers"),
    // flex: 1,
    type: "date",
    width: 150,
    valueGetter: (value: any) => {
      let returnValue: string | Date = "";
      if (value) {
        if (value === "summary") {
          returnValue = gettext("Period/Sum");
        } else {
          // returnValue = value;
          returnValue = new Date(value);
        }
      }
      return returnValue;
    },
    valueFormatter: (value: any) => {
      let returnValue = "";
      if (value) {
        if (Object.prototype.toString.call(value) === "[object Date]") {
          // returnValue = value;
          returnValue = formatDateDayMonthYearTime(value);
        } else {
          returnValue = value;
        }
      }
      return returnValue;
    },
  };
};

const numberColumn = (
  field: string,
  headerName: string,
  locale: string,
  width = 200,
) => {
  return {
    field,
    headerName,
    width,
    type: "number",
    valueFormatter: (value: number | string | null | undefined) =>
      toLocaleNumber(locale, value as any, 2),
    cellClassName: field === "sum" ? "bold" : "",
  };
};
